"use client";
import { Button } from "@/intent-components/ui/button";
import { Loader } from "@/intent-components/ui/loader";
import { Modal } from "@/intent-components/ui/modal";
import { IconTrash } from "@intentui/icons";
import { useRouter } from "next/navigation";
import { startTransition, useState } from "react";
import { deleteConfiguration } from "./delete-configuration";
type DeleteClientProps = {
  id: number;
  configName: string;
};

export function DeleteClient({ id, configName }: DeleteClientProps) {
  const router = useRouter();

  const [isConfirmingConfigDelete, setIsConfirmingConfigDelete] =
    useState(false);
  const [isDeletingConfig, setIsDeletingConfig] = useState(false);

  const handleDeleteConfiguration = async () => {
    setIsDeletingConfig(true);
    await deleteConfiguration(id);
    startTransition(() => {
      setIsConfirmingConfigDelete(false);
      setIsDeletingConfig(false);
      router.refresh();
    });
  };

  return (
    <>
      <Button
        size="square-petite"
        intent="outline"
        onPress={() => {
          setIsConfirmingConfigDelete(true);
        }}
      >
        <span className="text-(--danger)">
          <IconTrash />
        </span>
      </Button>

      <Modal
        isOpen={isConfirmingConfigDelete}
        onOpenChange={setIsConfirmingConfigDelete}
      >
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>Delete {configName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete {configName}?</Modal.Body>
          <Modal.Footer>
            <Modal.Close>Cancel</Modal.Close>
            <Button intent="danger" onPress={handleDeleteConfiguration}>
              {isDeletingConfig ? <Loader /> : <IconTrash />}
              Delete
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}
